import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import axios from "axios";
import {
  EmailShareButton,
  FacebookShareButton,
  TelegramShareButton,
  ViberShareButton,
  FacebookMessengerShareButton,
  WhatsappShareButton,
} from "react-share";
import {
  FacebookIcon,
  EmailIcon,
  FacebookMessengerIcon,
  TelegramIcon,
  ViberIcon,
  WhatsappIcon,
} from "react-share";
function QuarterPP({ post, modalIsOpen }) {
  const [counter, setCounter] = useState(post.counter);
  const [imageSrc, setImageSrc] = useState(require("../assets/candle.png"));
  const deletePosts = async () => {
    const accessToken = localStorage.getItem("accessToken");
    try {
      const response = await axios.delete(
        `https://radojicictijanaa.pythonanywhere.com/api/posts/${post.id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      window.location.href = "/";
    } catch (error) {
      console.log("Error fetching posts:", error);
    }
  };

  const handleCandleClick = () => {
    // Toggle between two image sources
    if (imageSrc === require("../assets/candle.png")) {
      setImageSrc(require("../assets/candleColor.png"));
    } else {
      setImageSrc(require("../assets/candle.png"));
    }
    increaseCounter();
  };

  const increaseCounter = async () => {
    try {
      setCounter(post.counter + 1);
      await axios.post(
        `https://radojicictijanaa.pythonanywhere.com/api/posts/${post.id}/counter/up/`,
        {}
      );
    } catch (error) {
      console.log("Error fetching posts:", error);
    }
  };

  const userRole = localStorage.getItem("userRole");
  return (
    <Container
      style={{ height: `${modalIsOpen ? "auto" : "145px"}` }}
      className="post poslednji-pozdrav"
      data-aos={"fade-up"}
    >
      {" "}
      <Row
        style={{
          fontStyle: "italic",
          border: "none",
          borderTop: "none",
          display: "flex",
          justifyContent: "end",
          paddingRight: "0.5rem",

          backgroundColor: "transparent",
          color: "gray",
          fontSize: "16px",
        }}
      >
        {post.type === "poslednji_pozdrav" ? "poslednji pozdrav" : post.type}
      </Row>
      <Row lg={12} md={12} sm={12}>
        {" "}
        <h4
          style={{
            fontSize: "20px",
            marginTop: "2.5rem",
            textAlign: "center",
            fontWeight: "bold",
          }}
        >
          {post.name}
        </h4>
        {modalIsOpen && (
          <Row>
            {" "}
            <span style={{ textAlign: "center" }}>Upali svijeću</span>
          </Row>
        )}
        {modalIsOpen && (
          <Row>
            {" "}
            <button
              style={{
                backgroundColor: "transparent",
                border: "none",
                alignItems: "center",
                borderRadius: "100%",
              }}
              onClick={handleCandleClick}
            >
              <img src={imageSrc} alt="Image" />
            </button>
          </Row>
        )}
        {modalIsOpen && (
          <Row style={{ paddingBottom: "0" }}>
            {" "}
            <span style={{ textAlign: "center" }}>{counter}</span>
          </Row>
        )}
        {modalIsOpen && (userRole === "admin" || userRole === "superadmin") && (
          <Col>
            <button
              style={{ marginBottom: "2%", float: "left" }}
              className="btn btn-danger"
              onClick={() => deletePosts()}
            >
              Obriši
            </button>
          </Col>
        )}
        {modalIsOpen && (
          <div
            style={{
              float: "right",
              paddingBottom: "2%",
              paddingRight: "1%",
              width: "auto",
            }}
          >
            <FacebookShareButton
              title="Facebook"
              url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
            >
              <FacebookIcon
                bgStyle={{ fill: "black" }}
                iconFillColor="white"
                size={25}
                round
              />
            </FacebookShareButton>
            <span title="Viber">
              <ViberShareButton
                url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
              >
                <ViberIcon
                  bgStyle={{ fill: "black" }}
                  iconFillColor="white"
                  size={25}
                  round
                />
              </ViberShareButton>
            </span>
            <EmailShareButton
              title="Email"
              url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
              subject="Check out this post"
            >
              <EmailIcon
                bgStyle={{ fill: "black" }}
                iconFillColor="white"
                size={25}
                round
              />
            </EmailShareButton>
            <FacebookMessengerShareButton
              title="Messenger"
              url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
            >
              <FacebookMessengerIcon
                bgStyle={{ fill: "black" }}
                iconFillColor="white"
                size={25}
                round
              />
            </FacebookMessengerShareButton>
            <span title="Telegram">
              <TelegramShareButton
                title="Telegram"
                url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
              >
                <TelegramIcon
                  bgStyle={{ fill: "black" }}
                  iconFillColor="white"
                  size={25}
                  round
                />
              </TelegramShareButton>
            </span>
            <span title="What's App">
              <WhatsappShareButton
                url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
                title="Check out this post"
              >
                <WhatsappIcon
                  bgStyle={{ fill: "black" }}
                  iconFillColor="white"
                  size={25}
                  round
                />
              </WhatsappShareButton>
            </span>
          </div>
        )}
      </Row>{" "}
    </Container>
  );
}

export default QuarterPP;
